import { useTranslation } from "react-i18next";
import { useChatLatestTimestamp } from "../../hooks/queries/useChatMessages";
import { useChatLastVisit } from "../../hooks/useChatLastVisit";

interface ChatTabTitleProps {
  tournamentId: number;
  /** When false, polling for the latest timestamp is paused — the user is on the chat tab and is seeing messages directly. */
  enablePolling: boolean;
}

function ChatTabTitle({ tournamentId, enablePolling }: ChatTabTitleProps) {
  const { t } = useTranslation();
  const { data: latest } = useChatLatestTimestamp(tournamentId, enablePolling);
  const lastVisit = useChatLastVisit(tournamentId);

  const hasMention = !!latest?.mentionTimestamp && new Date(latest.mentionTimestamp).getTime() > lastVisit;
  const hasUnread = !!latest?.timestamp && new Date(latest.timestamp).getTime() > lastVisit;

  return (
    <span className="chat-tab-title">
      {t("chat")}
      {hasMention
        ? <span className="nav-unread-dot mention ms-2" aria-label={t("unreadChatMention")} />
        : hasUnread && <span className="nav-unread-dot ms-2" aria-label={t("unreadChatMessages")} />}
    </span>
  );
}

export default ChatTabTitle;
